/* eslint import/no-extraneous-dependencies: 0 */
import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';

import { COLUMN_TYPES } from '../../../data-table/DataTableColumns';
import { FORMATTER_TYPES } from '../../../../utilities/FormattingUtilities';
import { filterId as agentFilterId } from '../../../filters/agent-filter/AgentFilter';
import { filterId as dateTimeFilterId } from '../../../filters/date-time-filter/DateTimeFilter';

export function getPathLogColumns(canDrillIn) {
    const metricFormatter = {
        type: FORMATTER_TYPES.DURATION,
        baseUnits: 's',
        maxDecimals: 3,
        forceDecimals: true,
        ltComparison: 0.001,
    };

    return [
        {
            type: COLUMN_TYPES.NUMERIC,
            title: t`Response Time`,
            width: 144,
            sortable: true,
            tooltip: false,
            mapping: 'avgResponse',
            formatter: metricFormatter,
        },
        {
            type: COLUMN_TYPES.NUMERIC,
            title: t`Path Delay`,
            width: 115,
            tooltip: false,
            mapping: 'pathLatency.avg',
            sortable: true,
            formatter: metricFormatter,
        },
        {
            type: COLUMN_TYPES.NUMERIC,
            title: t`Hops`,
            sortable: true,
            width: 76,
            tooltip: false,
            mapping: 'pathHops.avg',
        },
        {
            title: t`Host Name`,
            minWidth: 150,
            flex: 1,
            sortable: true,
            tooltip: false,
            resizable: false,
            sortProperty: 'pathDestDns',
            mapper: (row) => row?.pathDestDns || row?.pathDestIp,
        },
        {
            type: COLUMN_TYPES.LINK,
            width: 110,
            formatter: () => i18n._(t`Path Details`),
            uiOnly: true,
            hidden: !canDrillIn,
            link: {
                target: '/path-detail',
                state: { fromTestLogPage: true },
                mappedFilterParams: {
                    [agentFilterId]: 'agent',
                    [dateTimeFilterId]: 'testTime',
                },
            },
        },
    ];
}
